import { callApiToServer } from '../../callApi';

export async function addCoin(
  authtoken,
  coinObject,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
    
    let body = JSON.stringify({
        name: coinObject.name,
        price: parseFloat(coinObject.price)
    });
  
    let endUrl = "v1/auth/add-coin";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
